import React, {Component} from 'react';
import {connect} from 'react-redux';
import PageTitle from '../../../common/page-title/index';
import GroupsTable from './groups-table';
import {getGroups, removeGroup, downloadGroup, downloadGroups} from "../../../../actions/groups";
import GroupsNavigationHead from './groups-navigation-head';
import {history} from '../../../../store';
import RemoveGroupDialog from '../remove-group-dialog';
import {toast} from "react-toastify";
import FileDownload from "react-file-download";
import ToastMessage from "../../../common/toast-message";
import {stringToSnakeCase} from "../../../../utils/commonFunctions";

class GroupsPage extends Component {

  state = {
    pageNumber: 1,
    removeable: null,
  };

  handleDownloadAll() {
    downloadGroups()
      .then((response) => {
        this.downloadCsv("groups", response.data);
      })
      .catch(this.toastError);
  }

  handleDownload(id, name) {
    downloadGroup(id)
      .then((response) => {
        this.downloadCsv(name, response.data)
      })
      .catch(this.toastError);
  }

  formatFileName(groupName) {
    return `${stringToSnakeCase(groupName)}.csv`;
  }

  downloadCsv(groupName, data) {
    FileDownload(data, this.formatFileName(groupName));
  }

  toastError = (error) => toast.error(<ToastMessage iconStyle="error" message="Cannot download export data"/>);

  componentWillMount() {
    const {dispatch} = this.props;
    const {current_page} = this.props.paging;

    dispatch(getGroups(current_page)).then(() => this.resetPage());
  }

  resetPage() {
    this.setState({
      pageNumber: 1
    });
  }

  handlePageChange = (page, size) => {
    this.setState({pageNumber: page}, this.afterPageChange);
  };

  afterPageChange = () => {
    const {pageNumber} = this.state;
    this.props.dispatch(getGroups(pageNumber));
  };

  handleRemove(id) {
    this.setState({removeable: id});
  }

  handleConfirmRemove(result) {
    const {dispatch} = this.props;
    const {removeable} = this.state;

    if (result && removeable) {
      dispatch(removeGroup(removeable)).then(() => {
        this.resetPopup();
        dispatch(getGroups(this.props.paging.current_page))
      });
    } else {
      this.resetPopup();
    }

  }

  resetPopup() {
    this.setState({removeable: null});
  }

  handleNew() {
    history.push('/admin/groups/new')
  }

  render() {
    const {groups, loading} = this.props;
    const {current_page, per_page, total_count, total_pages} = this.props.paging;
    const {removeable} = this.state;

    return (
      <div className="container-fluid">
        <PageTitle>Groups</PageTitle>

        <GroupsNavigationHead
          handleNew={this.handleNew.bind(this)}
          downloadAll={this.handleDownloadAll.bind(this)}
        />

        <GroupsTable
          handleRemove={this.handleRemove.bind(this)}
          groups={groups}
          currentPage={parseInt(current_page)}
          sizePerPage={parseInt(per_page)}
          onPageChange={this.handlePageChange.bind(this)}
          totalPages={total_pages}
          total={total_count}
          download={this.handleDownload.bind(this)}
        />

        {removeable && <RemoveGroupDialog onClose={this.handleConfirmRemove.bind(this)}/>}

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    groups: state.groups.groups,
    paging: state.groups.meta,
    loading: !state.groups.fetched && state.groups.fetching,
  };
};

export default connect(mapStateToProps)(GroupsPage);


// WEBPACK FOOTER //
// ./src/components/admin/groups/list/groups-page.jsx